import React from 'react';
import clsx from 'clsx';
import { Stack, Text, Fabric, FontIcon } from 'office-ui-fabric-react';
import Footer from '../../components/Footer';
import styles from './MaintenancePage.style';
import { isMobileApp } from '../../utils';

const isMobile = isMobileApp();

const MaintenancePage = () => {
  return (
    <div className={styles.root}>
      <Fabric className={clsx(styles.root, isMobile && styles.mobile)}>
        <Stack className={styles.hero}>
          <Stack horizontal align="start" className={styles.heroHeader} data-testid="header">
            <FontIcon className={styles.iconClass} iconName="Warning12" arianame="Warning12" />
            <Text className={styles.textClass} block>
              Site Under Maintenance
            </Text>
          </Stack>
        </Stack>
        <Stack>
          <Footer />
        </Stack>
      </Fabric>
    </div>
  );
};

export default MaintenancePage;
